import React from "react";
import WagerTypes from "../constants/WagerTypes";
import EntriesTable from "./EntriesTable";

const High5 = ({
  raceInfo,
  entriesInfo,
  idHigh5,
  addToCart,
  disabledAll,
  checkBoxState,
}) => {
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="High5"
        role="tabpanel"
        aria-labelledby="High5"
      >
        <EntriesTable
          raceInfo={raceInfo}
          entriesInfo={entriesInfo}
          wt={WagerTypes.HIGH5.name}
          idWT={idHigh5}
          addToCart={addToCart}
          disabledAll={disabledAll}
          checkBoxState={checkBoxState}
        />
      </div>
    </>
  );
};

export default High5;
